import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { getTranslatedOptions } from '../../../../utils/translation'
import Button, { BUTTON_HEIGHT_40 } from '../../../Button'
import { ICON_HEIGHT_24 } from '../../../Icon'
import { ButtonIconSelectControl, ButtonSelect } from '../../../Select'

import * as styles from './RequestProfileHeaderFooterActionSelectButton.module.css'

function RequestProfileHeaderFooterActionSelectButton({
  Icon,
  className,
  options,
  qaName,
  text,
  onSelectOption,
}) {
  const { t } = useTranslation()

  return (
    <ButtonSelect
      Control={ButtonIconSelectControl}
      controlProps={{
        Button: Button.Text,
        buttonProps: {
          beforeIconProps: { Icon, height: ICON_HEIGHT_24 },
          className,
          height: BUTTON_HEIGHT_40,
          isInline: false,
          qaName,
          showTextTooltip: true,
          text,
        },
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottom,
        maxWidthByRef: false,
      }}
      dropdownProps={{
        className: styles.dropdown,
      }}
      listProps={{
        headerProps: {
          Search: null,
        },
      }}
      options={getTranslatedOptions({ options, t })}
      onSelectItem={onSelectOption}
    />
  )
}

export default RequestProfileHeaderFooterActionSelectButton
